import {
  getFilesURLs,
  getTendersURLs,
  getTenderVersionedFile,
  GetTenderVersionedFileParams,
  newSingleTenderDownload,
} from '~src/services/api';
import { saveFromLink } from '~src/utils/downloader/shared/saveFromLink';
import { DownloadingState, useStore } from '~src/store';
import { message } from 'antd';

const createWorker = () => {
  return new Worker(
    URL.createObjectURL(
      new Blob(
        [
          `self.onmessage = async (event) => {
            const { file } = event.data;
            try {
              const response = await fetch(file.url);
              
              if (!response.ok) {
                throw new Error(\`HTTP \${response.status} - \${response.statusText}\`);
              }

              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
              
              self.postMessage({ success: true, file, url });
            } catch (error) {
              console.error(\`Worker Error - File: \${file.file_name}, Error: \${error.message}\`);
              self.postMessage({ success: false, file, error: error.message });
            }
          };`,
        ],
        { type: 'application/javascript' }
      )
    )
  );
};

export const downloadVersionedFile = async (
  tenderId: number,
  projectId: number,
  tenderVersionedFileId: string,
  onDownloadStarted?: () => unknown
) => {
  useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);
  // console.log(
  //   `downloadVersionedFile`,
  //   tenderId,
  //   projectId,
  //   tenderVersionedFileId
  // );

  if (!tenderId) throw new Error(`No tender id`);
  if (!projectId) throw new Error(`No tender id`);
  if (!tenderVersionedFileId) throw new Error(`No tenderVersionedFileId id`);

  const registrationKey = await newSingleTenderDownload('registration key', {
    projectId: Number(projectId),
    tenderId: Number(tenderId),
    file_ids: tenderVersionedFileId,
  });

  //console.log(`registrationKey`, registrationKey);

  const fileUrl = await getTendersURLs(
    projectId,
    tenderId,
    registrationKey.map((key) => key.using_key)
  );

  //console.log(`fileUrl`, fileUrl);

  const worker = createWorker();

  const fileData = fileUrl[0];

  if (!fileData || !fileData.url) throw new Error('Invalid file URL received');

  const selectedFile = {
    file_name: registrationKey[0].file_name,
    url: fileData.url,
  };

  worker.postMessage({ file: selectedFile });

  worker.onmessage = (event) => {
    const { success, file, url, error } = event.data;
    if (success) {
      onDownloadStarted && onDownloadStarted();
      saveFromLink(url, file.file_name);
      //console.log(`Download started: ${file.file_name}`);
    } else {
      message.error(`ERROR: ${error}`);
      console.error(`Download failed for ${file.file_name}: ${error}`);
    }

    worker.terminate();
  };

  useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
  setTimeout(() => {
    useStore.getState().changeDownloadingActive(false);
  }, 3_000);
};

// export const downloadVersionedFile = async (
//   args: GetTenderVersionedFileParams,
//   onDownloadStarted?: () => unknown
// ) => {
//   const fileLocation = await getTenderVersionedFile(args);
//   useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);
//
//   if (fileLocation) {
//     onDownloadStarted && onDownloadStarted();
//
//     saveFromLink(fileLocation.location, fileLocation.title);
//
//     useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
//     setTimeout(() => {
//       useStore.getState().changeDownloadingActive(false);
//     }, 3_000);
//   }
//
//   useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
//   setTimeout(() => {
//     useStore.getState().changeDownloadingActive(false);
//   }, 3_000);
// };
